import { createFileRoute } from "@tanstack/react-router";

import { IdentityRosterPanel } from "../features/identity/IdentityRosterPanel";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/identity",
)({
  component: IdentityRoute,
});

function IdentityRoute() {
  const { tenantSlug } = Route.useParams();
  return <IdentityRosterPanel tenantSlug={tenantSlug} />;
}
